export default class ColorHelper {
  static instance;
  constructor() {
    const { primaryColor, secondaryColor } = window["boot"];
    this.primaryColor = primaryColor;
    this.secondaryColor = secondaryColor;
  }

  static getInstance() {
    if (ColorHelper.instance) {
      return ColorHelper.instance;
    }
    ColorHelper.instance = new ColorHelper();
    return ColorHelper.instance;
  }

  getPrimaryColor = (opacity = null) => {
    return this.hexToRGB(this.primaryColor, opacity);
  };

  getSecondaryColor = (opacity = null) => {
    return this.hexToRGB(this.secondaryColor, opacity);
  };

  getHeaderColorStyle = () => {
    return {
      backgroundColor: this.getPrimaryColor(),
      color: this.getSecondaryColor()
    };
  };

  getHeaderLogoColorStyle = () => {
    return {
      color: this.getSecondaryColor(0.5)
    };
  };

  getRightChatColorStyle = () => {
    return {
      backgroundColor: this.getPrimaryColor(0.2)
    };
  };

  getSecundaryBtnStyle = () => {
    return this.getChatSendColorStyle();
  };

  getChatControlColorStyle = () => {
    return {
      color: this.getPrimaryColor(0.5)
    };
  };
  getChatSendColorStyle = () => {
    return {
      backgroundColor: this.getPrimaryColor(0.5)
    };
  };

  getChatClockColorStyle = () => {
    return this.getChatSendColorStyle();
  };

  getMainChatBtnStyle = () => {
    return {
      color: this.getSecondaryColor(),
      backgroundColor: this.getPrimaryColor()
    };
  };

  getButtonColorStyle = () => {
    return {
      color: this.getSecondaryColor(),
      border: `1px solid ${this.getPrimaryColor(0.2)}`,
      textShadow: `0px 1px 0px ${this.getPrimaryColor(0.3)}`,
      backgroundColor: this.getPrimaryColor()
    };
  };

  getLoginTitleColor = () => {
    return {
      color: this.getPrimaryColor()
    };
  };

  hexToRGB = (hex, alpha) => {
    var r = parseInt(hex.slice(1, 3), 16),
      g = parseInt(hex.slice(3, 5), 16),
      b = parseInt(hex.slice(5, 7), 16);

    if (alpha) {
      return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
    } else {
      return "rgb(" + r + ", " + g + ", " + b + ")";
    }
  };
}
